import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as orgFunctionProposalActions from 'actions/admin/orgFunctionProposal';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';

const initialState = {
  loaded: false,
};

export const withAdminOrgFunctionProposal = (WrappedComponent) => {
  class WithOrgFunctionProposal extends BaseHOC {
    state = { ...initialState };

    async componentDidMount() {
      const { getAllOrgFunctionProposals } = this.props;
      if (!this.state.loaded) {
        try {
          await getAllOrgFunctionProposals();
        } finally {
          this.setState({ ...initialState, loaded: true });
        }
      }
    }

    approveOrgFunctionProposal = async (id) => {
      const { approveOrgFunctionProposal } = this.props;
      await approveOrgFunctionProposal(id);
    };

    rejectOrgFunctionProposal = async (id) => {
      const { rejectOrgFunctionProposal } = this.props;
      await rejectOrgFunctionProposal(id);
    };

    bulkDeleteOrgFunctionProposals = async (ids) => {
      const { bulkDeleteOrgFunctionProposals } = this.props;
      await this._deleteBulk(bulkDeleteOrgFunctionProposals, ids);
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          loaded={this.state.loaded}
          approveOrgFunctionProposal={this.approveOrgFunctionProposal}
          rejectOrgFunctionProposal={this.rejectOrgFunctionProposal}
          bulkDeleteOrgFunctionProposals={this.bulkDeleteOrgFunctionProposals}
        />
      );
    }
  }

  const mapStateToProps = ({ adminOrgFunctionProposal }) => ({
    adminOrgFunctionProposal,
  });

  const AdminOrgFunctionProposal = connect(
    mapStateToProps,
    orgFunctionProposalActions,
  )(WithOrgFunctionProposal);

  hoistNonReactStatics(AdminOrgFunctionProposal, WrappedComponent);

  return compose(withBaseHOCProps)(AdminOrgFunctionProposal);
};

export default withAdminOrgFunctionProposal;